// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SearchResult-allCategoryList-vC5Pz {
  position: relative;
  z-index: 1;
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  row-gap: 48px;
  -webkit-column-gap: 30px;
     -moz-column-gap: 30px;
          column-gap: 30px;
}

.SearchResult-allCategoryListItem-YtS_N:hover,
.SearchResult-allCategoryListItem-YtS_N:focus {
  cursor: pointer;
  text-decoration: unset;
}

.SearchResult-subCategoryNoListItem-sl0io {
  margin-top: 24px;
  margin-bottom: 24px;
  font-size: 16px;
  font-weight: 400;
  line-height: 26px;
  color: var(--secondary-foreground);
}

.SearchResult-subCategoryNoListImgContainer-ObsfL {
  width: 188px;
  height: 178px;
  margin: 0 auto;
  position: relative;
  margin-bottom: 24px;
}

.SearchResult-subCategoryNoListImgContainer-ObsfL img {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  -o-object-fit: contain;
     object-fit: contain;
}

@media (max-width: 1199px) and (min-width: 1024px) {
  .SearchResult-allCategoryList-vC5Pz {
    grid-template-columns: repeat(5, 1fr);
  }
}

@media (max-width: 1023px) and (min-width: 768px) {
  .SearchResult-allCategoryList-vC5Pz {
    grid-template-columns: repeat(4, 1fr);
  }
}

@media (max-width: 767px) {
  .SearchResult-subCategoryNoListItem-sl0io {
    margin-bottom: 0;
  }

  .SearchResult-allCategoryList-vC5Pz {
    row-gap: 30px;
    -webkit-column-gap: 18px;
       -moz-column-gap: 18px;
            column-gap: 18px;
  }
}

@media (max-width: 767px) and (min-width: 576px) {
  .SearchResult-allCategoryList-vC5Pz {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (max-width: 575px) and (min-width: 375px) {
  .SearchResult-allCategoryList-vC5Pz {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 374px) {
  .SearchResult-allCategoryList-vC5Pz {
    grid-template-columns: repeat(1, 1fr);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/search/SearchResults/SearchResult.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,qCAAqC;EACrC,aAAa;EACb,wBAAgB;KAAhB,qBAAgB;UAAhB,gBAAgB;AAClB;;AAEA;;EAEE,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kCAAkC;AACpC;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,sBAAmB;KAAnB,mBAAmB;AACrB;;AAGA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,wBAAgB;OAAhB,qBAAgB;YAAhB,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAGA;EACE;IACE,qCAAqC;EACvC;AACF","sourcesContent":[".allCategoryList {\n  position: relative;\n  z-index: 1;\n  display: grid;\n  grid-template-columns: repeat(7, 1fr);\n  row-gap: 48px;\n  column-gap: 30px;\n}\n\n.allCategoryListItem:hover,\n.allCategoryListItem:focus {\n  cursor: pointer;\n  text-decoration: unset;\n}\n\n.subCategoryNoListItem {\n  margin-top: 24px;\n  margin-bottom: 24px;\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 26px;\n  color: var(--secondary-foreground);\n}\n\n.subCategoryNoListImgContainer {\n  width: 188px;\n  height: 178px;\n  margin: 0 auto;\n  position: relative;\n  margin-bottom: 24px;\n}\n\n.subCategoryNoListImgContainer img {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n}\n\n\n@media (max-width: 1199px) and (min-width: 1024px) {\n  .allCategoryList {\n    grid-template-columns: repeat(5, 1fr);\n  }\n}\n\n@media (max-width: 1023px) and (min-width: 768px) {\n  .allCategoryList {\n    grid-template-columns: repeat(4, 1fr);\n  }\n}\n\n@media (max-width: 767px) {\n  .subCategoryNoListItem {\n    margin-bottom: 0;\n  }\n\n  .allCategoryList {\n    row-gap: 30px;\n    column-gap: 18px;\n  }\n}\n\n@media (max-width: 767px) and (min-width: 576px) {\n  .allCategoryList {\n    grid-template-columns: repeat(3, 1fr);\n  }\n}\n\n@media (max-width: 575px) and (min-width: 375px) {\n  .allCategoryList {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n\n@media (max-width: 374px) {\n  .allCategoryList {\n    grid-template-columns: repeat(1, 1fr);\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"allCategoryList": `SearchResult-allCategoryList-vC5Pz`,
	"allCategoryListItem": `SearchResult-allCategoryListItem-YtS_N`,
	"subCategoryNoListItem": `SearchResult-subCategoryNoListItem-sl0io`,
	"subCategoryNoListImgContainer": `SearchResult-subCategoryNoListImgContainer-ObsfL`
};
module.exports = ___CSS_LOADER_EXPORT___;
